import { useReactiveVar } from '@apollo/client';

import useFetchOrganizationsByUser from '../../../apis/graphql/organization/useFetchOrganizationsByUser';
import { selectedOrganizationIdVar } from '../../../constants';
import { UseGetUserCardItemProps, UserCardItem } from './types';

export const useGetUserCardItems = ({
  userCardItems,
  userCardTitles,
}: UseGetUserCardItemProps): Array<UserCardItem> => {
  const selectedOrganizationId = useReactiveVar(selectedOrganizationIdVar);
  const { data } = useFetchOrganizationsByUser();

  const userCardItemsWithoutUserOrgSwitch = userCardItems.filter((item) => item.title !== userCardTitles.switchOrg);
  const userCardItemsOnlySignOut = userCardItems.filter((item) => item.title === userCardTitles.signOut);

  if (!selectedOrganizationId) {
    return userCardItemsOnlySignOut;
  }

  if (!data) {
    return userCardItemsWithoutUserOrgSwitch;
  }

  switch (data?.length) {
    case 0:
      return userCardItemsOnlySignOut;
    case 1:
      return userCardItemsWithoutUserOrgSwitch;
    default:
      return userCardItems;
  }
};
